// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__NtPjN","container":"styles_container__MPkq6","title":"styles_title__DKKYl","apply_btn":"styles_apply_btn__ZqV-F","appPlay":"styles_appPlay__ak9Xz"};